<template>
  <div class="forms">
    <div>
      <div class="status warn">
        <h2 id="closure-title">Holiday closure</h2>
        <p>The Registry of Births, Deaths and Marriages on Level 32, 180 Ann Street, Brisbane will be closed from 4.30pm <strong>Friday 22 December 2023</strong> to <strong>Monday 1 January 2024</strong>.</p>
        <p>We will re-open on Tuesday 2 January 2024 at 8.30am.</p>
      </div>
      <h1 id="formTitle">{{ $route.name }}</h1>
    
      <form id="submitForm" v-if="!this.submitting">
        <ol class="questions">
          <li>
            <fieldset>
              <li>
                <label for="applicant">Certificate applicant</label>
                <input id="applicant" v-model="applicant" value="" name="applicant" type="text" required="required">              
              </li>
              <ul class="actions">
                  <li>
                    <strong><button @click="submit" id="submitButton">Add item</button></strong>
                  </li>
              </ul>
              
            </fieldset>
          </li>
        </ol>
      </form>
      <p v-else>Submitting</p>
    </div>


    
  </div>
</template>

<script>
import { API } from 'aws-amplify';

export default {
  name: 'TheOrder',
  data: function() {
    return {
      submitting: false,
      applicant: '' 
    }
  },
  mounted() {
    this.submitting = false
  },
  methods: {
    submit: function() {
      let data = {
        body: {
          "productIds": [ "birthcert-blueybe" ], "customerFields": { "applicant": this.applicant }
        }
      }
      this.submitting = true
      API.post('bdmformsapi', '/orders/item/add', data).then((res) => { 
        console.log(res)
        window.location = res.redirect
      }).catch(err => {
        this.submitting = false
        console.error(err, err.stack)
      }) 
    }
  }
}
</script>

